<template>
  <v-sheet :min-height="(countPosts + 2) * (28 + 9)" class="nWidget">
    <h1 class="fs-l d-flex justify-space-between">
      お知らせ

      <div>
        <v-btn
          v-if="pastCpLink"
          text
          small
          :to="{ name: 'pastCampaign' }"
          class="fs-xs fc-gray-6 font-weight-medium"
        >
          過去イベント
          <v-icon small>chevron_right</v-icon>
        </v-btn>

        <v-btn
          text
          small
          :to="{
            name: 'news',
          }"
          class="fs-xs fc-gray-6 font-weight-medium"
        >
          一覧で見る
          <v-icon small>chevron_right</v-icon>
        </v-btn>
      </div>
    </h1>

    <v-list class="mx-auto" max-width="1000px">
      <template v-if="importantPosts.length > 0">
        <template v-for="(item, index) in sortedImportantPostsByDate">
          <v-list-item
            class="nWidget-List_Item py-1"
            dense
            :key="'importantPost' + item.postId"
            :to="{ name: 'newsDetail', params: { postId: item.postId } }"
          >
            <v-list-item-subtitle class="nWidget-List_Date fc-gray-6 fs-xs">
              <DateFormat :date="item.date" :type="'0'"/>
            </v-list-item-subtitle>
            <v-list-item-title class="font-weight-bold">
              <v-icon class="mr-2" :color="ColorPrimary" small>error</v-icon>
              {{ item.title }}
            </v-list-item-title>
          </v-list-item>
          <v-divider
            class="ma-1"
            :key="'importantPostD' + index + 0.5"
            v-if="index < importantPosts.length"
          ></v-divider>
        </template>
      </template>

      <template v-for="(item, index) in sortedPostsByDate">
        <v-list-item
          class="nWidget-List_Item py-1"
          dense
          :key="'post' + item.postId"
          :to="{ name: 'newsDetail', params: { postId: item.postId } }"
        >
          <v-list-item-subtitle class="nWidget-List_Date fc-gray-6 fs-xs">
            <DateFormat :date="item.date" :type="'0'"/>
          </v-list-item-subtitle>
          <v-list-item-title class="font-weight-bold">{{
              item.title
            }}
          </v-list-item-title>
        </v-list-item>
        <v-divider
          class="ma-1"
          :key="'postD' + index + 0.5"
          v-if="index < countPosts - 1"
        ></v-divider>
      </template>
    </v-list>
  </v-sheet>
</template>

<script>
import axios from "axios";
import DateFormat from "@/components/DateFormat";

export default {
  name: "newsWidget",
  props: {
    countPosts: {
      mode: Number,
      default: 3,
    },
    pastCpLink: {
      mode: String,
      default: false,
    },
  },
  components: {
    DateFormat,
  },
  data() {
    return {
      // TODO:countPosts分の新着記事（重要をのぞく）を取得
      posts: [],
      // TODO:重要フラグつきの記事を全て取得
      importantPosts: [],
    };
  },
  async created() {
    try {
      /* お知らせ一覧 */
      const res = await axios.get(
        this.serverPath + "/api/News/getNewsListWidget",
        {
          //  params: {
          //    userId: this.$store.state.userId,
          //  },
        }
      );
      if (res.data) {
        this.posts = res.data.newsListWidget;
        this.importantPosts = res.data.newsListWidgetImportant;
      }
    } catch (error) {
      console.log(error);
    }
  },

  computed: {
    // dateで並べ替え
    sortedPostsByDate() {
      return this.posts.sort((a, b) => {
        return a.date > b.date ? -1 : a.date < b.date ? 1 : 0;
      });
    },
    sortedImportantPostsByDate() {
      return this.importantPosts.sort((a, b) => {
        return a.date > b.date ? -1 : a.date < b.date ? 1 : 0;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/sass/import.scss";

.nWidget {
  &-List {
    &_Item {
      flex-wrap: wrap;
      min-height: 20px;
      @include media($sm) {
        flex-wrap: nowrap;
      }
    }

    &_Date {
      flex: 0 0 120px;
    }
  }
}
</style>
